var React = require('react');

function IconRemove (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 47.1h100V53H0z"}));
}

IconRemove.defaultProps = {"className":"icon remove","viewBox":"0 0 100 100"};

module.exports = IconRemove;

IconRemove.default = IconRemove;



//////////////////
// WEBPACK FOOTER
// ./src/media/icon-remove.svg
// module id = 523
// module chunks = 0